import React, { Fragment } from "react";

interface IModalDetailsRow {
  label?: any;
  value?: any;
  icon?: any;
  type?: any;
  rows?: number;
}

export default function ModalDetailsRow({
  label,
  value,
  icon,
  type,
  rows,
}: IModalDetailsRow) {
  return (
    <Fragment>
      {type && type === "textarea" ? (
        <Fragment>
          <label className="label-txt">{label}</label>
          <div className="form-group inputWithIcon">
            <textarea
              className="user__form form-control text__area"
              readOnly
              value={value}
              rows={rows || 3}
            />
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <label className="label-txt">{label}</label>
          <div className="form-group inputWithIcon">
            <input
              type="text"
              className="user__form form-control"
              readOnly
              value={value}
            />
            <i className={icon} />
          </div>
        </Fragment>
      )}
    </Fragment>
  );
}
